module.exports = __webpack_public_path__ + "assets/img/NPC039.9d0d1d80.png";